import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ThemeProvider, Toaster } from "@clones/ui";
import { router } from "./router";
import "./globals.css";
const queries = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => {
        const status = (error as { status?: number }).status;
        return ![401, 403, 404, 409, 422].includes(status ?? 0) && count < 1;
      },
      staleTime: 15_000,
    },
  },
});
const target = document.getElementById("root");
if (!target) throw new Error("Studio root missing");
createRoot(target).render(
  <StrictMode>
    <ThemeProvider defaultDesign="studio">
      <QueryClientProvider client={queries}>
        <RouterProvider router={router} />
        <Toaster richColors closeButton position="top-right" />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
